"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var warning_1 = __importDefault(require("warning"));
function warnMissingIndex(index, name, parentName) {
    warning_1.default(typeof index === 'number', name + ": missing `index` prop. If you use " + name + " as non-direct children of " + parentName + ", you must provide a unique index prop.");
}
exports.default = warnMissingIndex;
